import { lazy, type ComponentType } from 'react';

/**
 * `React.lazy()` requires modules with a default export. Our page files use
 * named exports (better for refactor tools and tree-shaking), so this helper
 * adapts a named-export module into the shape `lazy()` expects.
 *
 *   const AboutPage = lazyNamed(() => import('@/pages/public/AboutPage'), 'AboutPage');
 */
export function lazyNamed<K extends string>(
  loader: () => Promise<Record<K, ComponentType<unknown>>>,
  name: K,
) {
  return lazy(() => loader().then((m) => ({ default: m[name] })));
}
